import { Avatar, Icon, useTheme } from '@salecycle/ui-component-library';
import { FC, useState } from 'react';
import {
  AlertProps,
  AlertElement,
  AlertHeader,
  AlertHeaderContent,
  AlertHeaderWrapper,
  AlertText,
  CloseButtonElement,
  getErrorColorFromType,
  getErrorIconFromType,
  IconSpan,
} from './Alert2.styles';

/*
  Experimental replacement for Alert component - once this has been tested, will move
  it to UCL and replace the existing Alert component with this. 
*/

export const Alert2: FC<AlertProps> = props => {
  const [alertVisible, setAlertVisible] = useState(true);
  const theme = useTheme();

  const alertColor = getErrorColorFromType(props.variation, theme);

  function hideAlert() {
    if (props.onClose) {
      props.onClose();
    }
    setAlertVisible(false);
  }

  if (!alertVisible) {
    return null;
  }

  return (
    <AlertElement {...props} variation={props.variation} data-testid="Alert">
      <AlertHeaderWrapper>
        <AlertHeaderContent>
          <IconSpan>
            <Avatar icon={getErrorIconFromType(props.variation)} bg={alertColor} />
          </IconSpan>
          <AlertHeader>
            {props.heading}
            {props.headingElement}
          </AlertHeader>
        </AlertHeaderContent>

        {props.onClose && (
          <CloseButtonElement
            data-testid="CloseButton"
            onClick={e => {
              e.preventDefault();
              hideAlert();
            }}
          >
            <Icon icon="times" color={theme.vars.newColor.darkGS2} />
          </CloseButtonElement>
        )}
      </AlertHeaderWrapper>

      {props.children && <AlertText>{props.children}</AlertText>}
    </AlertElement>
  );
};

const defaultProps: AlertProps = {
  maxWidth: '800px',
};

Alert2.defaultProps = defaultProps;
